/**
 * Wire types for Unstable Legion's peer-to-peer mesh.
 *
 * Three Trystero action payloads:
 *   - `cap` — `MeshPeerCap`, capability advertisement (on join + 30s heartbeat + change)
 *   - `cm`  — `MeshChatMessage`, chat over Codec msgpack frames
 *   - `tc`  — `MeshToolCall` / `MeshToolResult`, tool invocation
 *
 * Schemas are versioned (`v: 1`) so a future protocol bump can be
 * gated without crashing stale tabs.
 *
 * The wire types deliberately don't try to satisfy Trystero's
 * `DataPayload` constraint structurally — that constraint excludes
 * readonly arrays, optional fields, and `unknown`, all of which the
 * domain types want for ergonomics. The peer module casts through
 * `unknown` once at the wire boundary, with runtime type-guards
 * carrying the safety burden (see `guards.ts`).
 */
/** Wire-format version. Bump when shape changes. */
export const MESH_PROTOCOL_VERSION = 1;
